





































import Vue from "vue";
import AdminService from "@/services/adminService";
import SharedFilesService from "@/services/sharedFilesService";
import {Item} from "@/models/sharedFiles";

export default Vue.extend({
  name: "IntegrationSummary",

  data() {
    let tmp: any;
    return {
      file: tmp,
      data: [] as Item[],
      isLoaded: false,
      uploading: false,
      deleting: false
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoaded = true;
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const adminService = new AdminService(jwt);
        const response = await adminService.getIntegrationSummary();
        if (response !== undefined && response !== null) {
          if (response.data !== undefined && response.data !== null) {
            this.data = response.data.data;
          }
        }
      }
      this.isLoaded = false;
    },
    handleFileUpload(e) {
      this.file = e.target.files[0]
    },
    async submit(e) {
      this.uploading = true;
      e.preventDefault();
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          const adminService = new AdminService(jwt);
          const response = await adminService.uploadIntegrationSummary(formData);
          if (response && response.status == 200) {
            if (response.data) {
              this.uploading = false;
              alert("Upload Successfully");
              await this.getList();
            }
          }
        } catch (error) {
          this.uploading = false;
          alert(JSON.stringify(error.response.data));
        }
      }
    },
    async deleteFile(e, name) {
      e.preventDefault();
      if (this.deleting) {
        return;
      }
      if (confirm("Are you sure you want to delete " + name)) {
        this.isLoaded = true;
        const jwt = window.localStorage.getItem("jwt");
        if (jwt) {
          const adminService = new AdminService(jwt);
          try {
            const response = await adminService.deleteIntegrationSummary();
            if (response && response.status == 200) {
              if (response.data) {
                alert(response.data);
                await this.getList();
                this.isLoaded = false;
              }
            }
          } catch (e) {
            alert(JSON.stringify(e.response.data));
            this.isLoaded = false;
          }
        }
      }
    },
    async cancel() {
      await this.$router.push("/admin-panel");
    }
  }
});
